import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebook, faInstagram } from '@fortawesome/free-brands-svg-icons';

export default function Footer() {
  return (
    <footer style={{
      background: '#2d2926',
      color: '#c4b9ad',
      padding: '64px 40px 32px',
      fontFamily: "'Lato', sans-serif",
    }}>
      <div style={{
        maxWidth: '1100px',
        margin: '0 auto',
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
        gap: '48px',
        textAlign: 'left',
        marginBottom: '48px',
      }}>

        {/* Brand */}
        <div>
          <h6 style={{
            fontFamily: "'Josefin Sans', sans-serif",
            fontSize: '11px',
            letterSpacing: '4px',
            textTransform: 'uppercase',
            color: '#c9a96e',
            marginBottom: '20px',
          }}>
            Cascade Mountain Ranch
          </h6>
          <p style={{ fontSize: '15px', lineHeight: '2', margin: 0 }}>2500 Jumpoff Joe Creek Rd</p>
          <p style={{ fontSize: '15px', lineHeight: '2', margin: 0 }}>Grants Pass, OR 97526</p>
          <div style={{ marginTop: '20px', display: 'flex', gap: '16px' }}>
            <a href="https://www.facebook.com/CascadeMountainRanch/" target="_blank" rel="noreferrer"
              style={{ color: '#c4b9ad', fontSize: '20px', transition: 'color 0.3s' }}
              onMouseEnter={e => e.currentTarget.style.color = '#c9a96e'}
              onMouseLeave={e => e.currentTarget.style.color = '#c4b9ad'}>
              <FontAwesomeIcon icon={faFacebook} />
            </a>
            <a href="https://www.instagram.com/cascade_mountain_ranch/" target="_blank" rel="noreferrer"
              style={{ color: '#c4b9ad', fontSize: '20px', transition: 'color 0.3s' }}
              onMouseEnter={e => e.currentTarget.style.color = '#c9a96e'}
              onMouseLeave={e => e.currentTarget.style.color = '#c4b9ad'}>
              <FontAwesomeIcon icon={faInstagram} />
            </a>
          </div>
        </div>

        {/* Links */}
        <div>
          <h6 style={{
            fontFamily: "'Josefin Sans', sans-serif",
            fontSize: '11px',
            letterSpacing: '4px',
            textTransform: 'uppercase',
            color: '#c9a96e',
            marginBottom: '20px',
          }}>
            Explore
          </h6>
          {[
            { label: 'Home', href: '/' },
            { label: 'The Venue', href: '/venue' },
            { label: 'Pricing', href: '/packages' },
            { label: 'Gallery', href: '/gallery' },
            { label: 'Vendors', href: '/vendors' },
            { label: 'About', href: '/about' },
          ].map(link => (
            <p key={link.label} style={{ margin: '0 0 8px' }}>
              <a href={link.href} style={{
                color: '#c4b9ad',
                textDecoration: 'none',
                fontSize: '15px',
                transition: 'color 0.3s',
              }}
                onMouseEnter={e => e.currentTarget.style.color = '#c9a96e'}
                onMouseLeave={e => e.currentTarget.style.color = '#c4b9ad'}>
                {link.label}
              </a>
            </p>
          ))}
        </div>

        {/* Contact */}
        <div>
          <h6 style={{
            fontFamily: "'Josefin Sans', sans-serif",
            fontSize: '11px',
            letterSpacing: '4px',
            textTransform: 'uppercase',
            color: '#c9a96e',
            marginBottom: '20px',
          }}>
            Contact
          </h6>
          <p style={{ fontSize: '15px', lineHeight: '2', margin: '0 0 8px' }}>
            <a href="tel:5418908436" style={{ color: '#c4b9ad', textDecoration: 'none' }}>
              (541) 890-8436
            </a>
          </p>
          <p style={{ fontSize: '15px', lineHeight: '2', margin: '0 0 24px' }}>
            <a href="mailto:getaway@usa.com" style={{ color: '#c4b9ad', textDecoration: 'none' }}>
              getaway@usa.com
            </a>
          </p>
          <a href="/contact" style={{
            display: 'inline-block',
            border: '1px solid #c9a96e',
            color: '#c9a96e',
            padding: '10px 28px',
            fontSize: '10px',
            letterSpacing: '3px',
            textTransform: 'uppercase',
            textDecoration: 'none',
            fontFamily: "'Josefin Sans', sans-serif",
            transition: 'background 0.3s, color 0.3s',
          }}
            onMouseEnter={e => { e.currentTarget.style.background = '#c9a96e'; e.currentTarget.style.color = 'white'; }}
            onMouseLeave={e => { e.currentTarget.style.background = 'transparent'; e.currentTarget.style.color = '#c9a96e'; }}>
            Get in Touch
          </a>
        </div>

      </div>

      {/* Bottom bar */}
      <div style={{
        borderTop: '1px solid rgba(255,255,255,0.08)',
        paddingTop: '24px',
        textAlign: 'center',
        fontSize: '12px',
        letterSpacing: '1px',
        color: '#6b635d',
        fontFamily: "'Josefin Sans', sans-serif",
      }}>
        © {new Date().getFullYear()} Cascade Mountain Ranch · Hugo, Oregon
      </div>
    </footer>
  );
}
